/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ResourceCalculationMode {
  PERSONS = 'persons',
  TICKETS = 'tickets',
  STATIC = 'static',
}
